export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";


export const ADD_TO_CART = "ADD_TO_CART"
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST"

export const REMOVE_TO_CART = "REMOVE_TO_CART"
export const REMOVE_TO_WISHLIST = "REMOVE_TO_WISHLIST"